import revive_payload_client_4sVQNw7RlN from "/app/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/app/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/app/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/app/node_modules/nuxt/dist/app/plugins/payload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/app/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import plugin_vue3_A0OWXRrUgq from "/app/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/app/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import primevue_plugin_egKpok8Auk from "/app/.nuxt/primevue-plugin.mjs";
import plugin_client_8fz26Kfk5j from "/app/node_modules/nuxt-primevue/dist/runtime/plugin.client.mjs";
import chunk_reload_client_UciE0i6zes from "/app/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import auth_ANExhJHvcR from "/app/plugins/auth.js";
import helpers_ipnH1tCNhR from "/app/plugins/helpers.js";
import new_version_reload_client_pxKNZJWwWl from "/app/plugins/new-version-reload.client.js";
import online_status_watcher_client_5kA3H6d6eD from "/app/plugins/online-status-watcher.client.js";
import prevent_drop_navigation_client_go2SPh9ws6 from "/app/plugins/prevent-drop-navigation.client.js";
import sentry_client_GoGQuZo4Et from "/app/plugins/sentry.client.js";
import toast_client_437j7GlIrd from "/app/plugins/toast.client.js";
import vue_query_wrmMkNpEpe from "/app/plugins/vue-query.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  check_outdated_build_client_8vK7RkfGxZ,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  primevue_plugin_egKpok8Auk,
  plugin_client_8fz26Kfk5j,
  chunk_reload_client_UciE0i6zes,
  auth_ANExhJHvcR,
  helpers_ipnH1tCNhR,
  new_version_reload_client_pxKNZJWwWl,
  online_status_watcher_client_5kA3H6d6eD,
  prevent_drop_navigation_client_go2SPh9ws6,
  sentry_client_GoGQuZo4Et,
  toast_client_437j7GlIrd,
  vue_query_wrmMkNpEpe
]